import React from "react"

const contactsContext = React.createContext({
	contacts: [],
	saveAllContacts: (datas) => {}
})

export default contactsContext